import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router, UrlTree } from '@angular/router';

import { AccessRight } from 'models';
import { AuthenticatedUserService } from 'services';

export const StudioAnneloesBrandIds = [
    '5d02652634209e001210f727' // staging | development | production
];
@Injectable()
export class StudioAnneloesGuard {
    constructor(
        private authenticatedUserService: AuthenticatedUserService,
        private router: Router
    ) {}

    public canActivate(): Observable<boolean | UrlTree> {
        return this.authenticatedUserService
            .getAllowedBrands(
                AccessRight.OrderViaB2bPlatform,
                this.authenticatedUserService.user.value.organization._id
            )
            .pipe(
                map((allowedBrands) => {
                    const allowedBrandsIds = allowedBrands.map(({ _id }) => _id);
                    if (_.intersection(allowedBrandsIds, StudioAnneloesBrandIds).length > 0) {
                        return true;
                    }

                    this.router.navigate(['news']);
                    return false;
                })
            );
    }
}
